import NotFound from "./undraw_page_not_found_re_e9o6.svg";
import LandingPage from "./undraw_tweetstorm_re_n0rs.svg"

export const IMAGES = {
    NotFound,
    LandingPage
 }